import { render, staticRenderFns } from "./widget-service.vue?vue&type=template&id=3fa6e4b7&scoped=true"
import script from "./widget-service.vue?vue&type=script&lang=ts"
export * from "./widget-service.vue?vue&type=script&lang=ts"
import style0 from "./widget-service.vue?vue&type=style&index=0&id=3fa6e4b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa6e4b7",
  null
  
)

export default component.exports